module.exports = __webpack_public_path__ + "static/media/logoSeebiz.69c6a559.svg";